export default __webpack_public_path__ + "2b14ae9079ddd916ae65c5c6027fd843.png";